import { render } from "./indexsevenfooter.vue?vue&type=template&id=c6da2500"
import script from "./indexsevenfooter.vue?vue&type=script&lang=js"
export * from "./indexsevenfooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__